import styled from '@emotion/styled';
import { motion } from 'framer-motion';
export const ChatHistoryWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10001;
  pointer-events: none;
`;
export const ModalOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
`;
export const ModalContent = styled(motion.div)`
  background: white;
  
  .dark & {
    background: #1f2937;
  }
  
  border-radius: 1rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  width: 90%;
  max-width: 600px;
  height: 80vh;
  max-height: 700px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;

  @media (max-width: 640px) {
    width: 95%;
    height: 90vh;
    border-radius: 0.75rem;
  }
`;
export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
  .dark & {
    border-bottom: 1px solid #374151;
  }

  h2 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #111827;
    .dark & {
      color: #f9fafb;
    }
    margin: 0;
  }
`;
export const SearchBar = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e5e7eb;
  .dark & {
    border-bottom: 1px solid #374151;
  }

  svg {
    color: #6b7280;
    flex-shrink: 0;
  }

  input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-size: 1rem;
    color: #111827;
    .dark & {
      color: #f9fafb;
    }

    &::placeholder {
      color: #9ca3af;
    }
  }
`;
export const ChatList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0.5rem;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f3f4f6;
    .dark & {
      background: #374151;
    }
  }
  }

  &::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 3px;
    .dark & {
      background: #4b5563;
    }

    &:hover {
      background: #9ca3af;
      .dark & {
        background: #6b7280;
      }
    }
  }
`;
export const ChatItem = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  margin: 0.25rem;
  border-radius: 0.75rem;
  cursor: pointer;
  transition: background-color 0.2s;
  background-color: #f9fafb;
  .dark & {
    background-color: #374151;
  }

  &:hover {
    background-color: #f3f4f6;
    .dark & {
      background-color: #4b5563;
    }
  }

  .chat-info {
    flex: 1;
    overflow: hidden;

    h3 {
      font-size: 1rem;
      font-weight: 500;
      color: #111827;
      .dark & {
        color: #f9fafb;
      }
      margin: 0 0 0.25rem 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .last-message {
      font-size: 0.875rem;
      color: #6b7280;
      .dark & {
        color: #9ca3af;
      }
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .chat-meta {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.25rem;
    flex-shrink: 0;
    margin-left: 1rem;

    .date {
      font-size: 0.75rem;
      color: #9ca3af;
      .dark & {
        color: #6b7280;
      }
    }

    .message-count {
      font-size: 0.75rem;
      color: #6b7280;
      .dark & {
        color: #9ca3af;
      }
      background-color: #e5e7eb;
      .dark & {
        background-color: #4b5563;
      }
      padding: 0.125rem 0.5rem;
      border-radius: 9999px;
    }
  }
`;
export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #9ca3af;
  gap: 1rem;

  svg {
    color: #d1d5db;
  }

  p {
    font-size: 1rem;
    margin: 0;
  }
`;
